import { render, staticRenderFns } from "./OrderQuery.vue?vue&type=template&id=0ecd4ce2&scoped=true"
import script from "./OrderQuery.vue?vue&type=script&lang=js"
export * from "./OrderQuery.vue?vue&type=script&lang=js"
import style0 from "./OrderQuery.vue?vue&type=style&index=0&id=0ecd4ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecd4ce2",
  null
  
)

export default component.exports